/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs */

const en_gc_search_guides_what_is_gridcraft_description = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn what GridCraft is, who builds it, what its spreadsheet tools do, and how to choose between the online editor and desktop downloads.`)
};

const zh_gc_search_guides_what_is_gridcraft_description = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解 GridCraft 是什么、由谁开发、有哪些电子表格工具，以及如何选择在线编辑器或桌面下载版本。`)
};

/**
* | output |
* | --- |
* | "Learn what GridCraft is, who builds it, what its spreadsheet tools do, and how to choose between the online editor and desktop downloads." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_description = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_description(inputs)
	return zh_gc_search_guides_what_is_gridcraft_description(inputs)
});
export { gc_search_guides_what_is_gridcraft_description as "gc.search_guides.what_is_gridcraft.description" }